import React, { useEffect, useMemo, useState } from "react";
import { IVoucher } from "../Models";
import { Alert, Button, Col, Form, InputGroup } from "react-bootstrap";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { useDispatch } from "react-redux";
import { verifyDiscountCode } from "../Actions";
// import SvgEye from "../../Shared/Icons/bootstrap/Eye";
import { IErrorDictionary } from "../ApiCalls/ApiCallReducer";
import { formatteraTal, getErrorAsStrings } from "../Shared/Utils";
import SvgGiftFill from "../../Shared/Icons/bootstrap/GiftFill";
import SvgCheckCircle from "../../Shared/Icons/bootstrap/CheckCircle";

const commonStrings = getStrings().component.common;
const strings = getStrings().component.orderDetails.discountCode;

export interface IVouchersProperties {
	bookingNumber: string;
	email?: string;
	vouchers?: IVoucher[];
	error?: string|IErrorDictionary;
	remainingAmount: number;
	travelDates?: string[];
};

export const DiscountCodes = (props: IVouchersProperties) => {

	const [show, setShow] = useState(false);
	const [code, setCode] = useState("");
	const dispatch = useDispatch();

	const error = useMemo(() => {
		const messages = getErrorAsStrings(props.error);
		return messages?.join(", ");
	}, [props.error]);

	const submit = () => {
		if (!code)
			return;

		dispatch(verifyDiscountCode(props.bookingNumber, code, props.email, props.travelDates));
	};

	//Töm inputrutan när vouchern registrerats
	useEffect(() => {
		if (props.vouchers?.length > 0 && props.vouchers.some(x => x.voucherCode === code))
			setCode("");
	}, [props.vouchers]);

	if (!show)
		return <Button variant="link" className="pl-0 mt-2" onClick={() => setShow(true)}> {strings.showSectionButton}</Button>

	return <section className="vouchers">
		<h2>{strings.sectionHeading}</h2>

		{props.vouchers?.length > 0 && <ul className="list-unstyled">
			{props.vouchers.map((v, idx) => <li key={idx} className="text-success"><SvgCheckCircle className="mr-2" /> <strong>{v.voucherCode?.toUpperCase()}</strong>, {v.percent > 0 ? `${v.percent} %` : formatteraTal(v.amount, commonStrings.sek, 2)} rabatt.</li>)}
		</ul>}

		<Alert variant="danger" show={error ? true : false}>
			{error}<br />
			{strings.errorInfo}
		</Alert>

		{(!props.vouchers || props.vouchers?.length === 0) &&
			<Form.Row>
				<Form.Group as={Col} controlId="addvoucher">
					<InputGroup>
						<InputGroup.Prepend><InputGroup.Text><SvgGiftFill /></InputGroup.Text></InputGroup.Prepend>
						<Form.Control type="text" aria-label={strings.addDiscountCodeLabel} placeholder={strings.addDiscountCodeLabel}
							value={code} onChange={e => setCode(e.currentTarget.value?.trim())} disabled={props.remainingAmount <= 0} />
					</InputGroup>
				</Form.Group>
				<Col>
					<Button variant="success" disabled={!code} onClick={submit}>{strings.addDiscountCodeButton}</Button>
				</Col>
			</Form.Row>
		}
	</section>
}